/**
 * Determines if both mar and non-mar files exist in the given list of files.
 *
 * @param files files to search thru
 * @returns boolean - if mar and non-mar files are both found in the given list of files
 */
export const containsBothMarAndNonMarFiles = <T extends File>(files: T[]): boolean => {
  let mar = false,
    nonMar = false;

  files.forEach(file => {
    if (isMarFile(file)) {
      mar = true;
    } else {
      nonMar = true;
    }
  });

  return mar && nonMar;
};

/**
 * Counts the number of MAR files in the given list of files.
 *
 * @param files files to search thru
 * @returns int - count of the mar files
 */
export const countMarFiles = <T extends File>(files: T[]): number => {
  let count = 0;
  if (files) {
    files.forEach(file => {
      if (isMarFile(file)) {
        count++;
      }
    });
  }

  return count;
};

/**
 * Determines if the given file is a MAR file.
 *
 * @param file file to use
 * @returns boolean - if the file is a MAR file
 */
export const isMarFile = <T extends File>(file: T): boolean => {
  if (file) {
    const fileExtension: string = getFileExtension(file);
    return fileExtension.toLowerCase() === 'mar';
  } else {
    return false;
  }
};

/**
 * Determines if the given file is a JSON file.
 *
 * @param file file to use
 * @returns boolean - if the file is a json file
 */
export const isJsonFile = <T extends File>(file: T): boolean => {
  if (file) {
    const fileExtension: string = getFileExtension(file);
    return fileExtension.toLowerCase() === 'json';
  } else {
    return false;
  }
};

/**
 * Returns the extension of the given file.
 *
 * @param file
 * @returns string - the extension of the given file
 */
export const getFileExtension = (file: File) => {
  if (file) {
    return file.name.split('.').pop() || '';
  } else {
    return '';
  }
};

export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return '0 B';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const buildRegExp = (name: any, searchKeyWord: string | undefined) => {
  if (searchKeyWord !== undefined && searchKeyWord !== '') {
    //escape special characters for RegExp
    const keyWord = String(searchKeyWord).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    //  case insensitive regexp
    const searchTextRegExp = new RegExp(keyWord as any, 'i');
    name = name.replace(searchTextRegExp, '<b>$&</b>');
  }
  return name;
};
